import React from 'react';
import { AccentH5 } from 'scy/text';
import { uppercase } from 'scy/text/styles.mod.scss';
import Icon from './Icon';

export default function Title({ paymentMethod = {} }) {
  return (
    <>
      <Icon paymentMethod={paymentMethod} />
      <AccentH5 tag="h2" className={uppercase}>
        {paymentMethod.brand} {paymentMethod.last4}
      </AccentH5>
    </>
  );
}
